import { getAPI } from "../../../api/Networking";
import { Warehouse } from "../../../models/Warehouse/Warehouse";

export interface WarehouseRow {
  id: string;
  identifier: string;
  city_id: number;
  city_name: string;
  city_sku: string;
  admin_id: number;
  admin_name: string;
  active: boolean;
  address_line_1: string | null;
  address_line_2: string | null;
  landmark: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
  country_code: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  gstin: string | null;
  created_date: string;
  modified_date: string;
}

export default class WarehouseAPI {
  searchWarehouse = async (params?: {
    city_id?: number | null;
    active?: boolean;
    search_text?: string;
  }): Promise<Warehouse[]> => {
    try {
      const query: Record<string, string | number | boolean> = {};
      if (params?.city_id != null) query.city_id = params.city_id;
      if (params?.active != null) query.active = params.active;
      if (params?.search_text) query.search_text = params.search_text;

      const response = await getAPI("/v1/inventory/warehouses", query);
      return ((response.result ?? []) as WarehouseRow[]).map((item) => ({
        ...item,
        created_date: new Date(item.created_date),
        modified_date: new Date(item.modified_date),
      }));
    } catch (error) {
      throw error;
    }
  };

  searchWarehouseRack = async (warehouse_id: string, search_text: string) => {
    try {
      const response = await getAPI(
        `/v5/inventories/warehouse/racks?search_text=${search_text}&warehouse_id=${warehouse_id}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
